import { useEffect } from 'react';
import { useEntityDetails } from './useEntityDetails';
import { syncOrgAssessmentLinkPreferences } from '../utils/orgAssessmentLinkPreferences';

/** Keeps copy-link base URL in sync with the active org's short-link setting. */
export function useOrgAssessmentLinkPreferencesSync(entityId: string | null | undefined): void {
    const { data: entityDetails } = useEntityDetails(entityId);

    useEffect(() => {
        syncOrgAssessmentLinkPreferences(
            entityId,
            entityDetails?.shortAssessmentLinksEnabled ?? false
        );
    }, [entityId, entityDetails?.shortAssessmentLinksEnabled]);
}
